import { getCookieByName } from './util';
import { checkResponseForAuthFailure } from './authFailure';

/**
 * Bryntum's AjaxHelper wrappers that attach the auth/culture headers.
 *
 * AjaxHelper is a standalone XHR wrapper, so it sits outside both interceptors that normally add
 * Authorization -- axiosConfig's securityWorker (apiClient) and the vue-resource interceptor in
 * services/api.js. Every call site therefore had to remember the headers itself, and most did not:
 * harmless while the API was anonymous, a 401 on every one of them once authentication was enforced.
 *
 * This build of Bryntum offers no global hook (AjaxHelper exposes only fetch/get/post -- no
 * defaultHeaders), so the headers are injected here instead. Use these two functions rather than
 * bryntum.scheduler.AjaxHelper.get/post directly.
 */

function withAuthHeaders(options = {}) {
  const tokenType = getCookieByName('tokenType');
  const token = getCookieByName('token');

  return {
    ...options,
    headers: {
      Culture: localStorage.getItem('vue-lang'),
      // Omitted entirely when not signed in, instead of sending the literal "undefined undefined".
      ...(tokenType && token ? { Authorization: `${tokenType} ${token}` } : {}),
      // Caller headers win, so a call site can still override Accept, Content-Type, etc.
      ...options.headers,
    },
  };
}

export function ajaxGet(url, options) {
  return bryntum.scheduler.AjaxHelper.get(url, withAuthHeaders(options))
    .then(checkResponseForAuthFailure);
}

export function ajaxPost(url, payload, options) {
  return bryntum.scheduler.AjaxHelper.post(url, payload, withAuthHeaders(options))
    .then(checkResponseForAuthFailure);
}
